import { fetch, get } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, HttpCacheType } from "../../common";
/**
 * @class AssigneeShopInfoService handles assigneeshopinfo  api call
 */
export class AssigneeShopInfoService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
        this.apiUrl = EnvironmentService.getEnvironment().appApi;
    }
    static getInstance() {
        if (!AssigneeShopInfoService.instance) {
            AssigneeShopInfoService.instance = new AssigneeShopInfoService();
        }
        return AssigneeShopInfoService.instance;
    }
    /**
     * this method is used to fetch assignee shop info
     * @param assigneeCode represents the assignee code required to fetch assignee shop info
     * @returns IAssigneeShopInfoResponse
     */
    getAssigneeShopInfo(assigneeCode) {
        const pragma = { Pragma: HttpCacheType.NO_CACHE };
        const url = `${this.apiUrl}AssigneeShopInfo/${assigneeCode}`;
        const request = new Request(url, {
            cache: HttpCacheType.NO_CACHE
        });
        return get(request, pragma, this.fetchWrapper);
    }
}
//# sourceMappingURL=AssigneeShopInfoService.js.map